"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _StepLabel.default;
  }
});

var _StepLabel = _interopRequireDefault(require("./StepLabel"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/StepLabel/index.js
// module id = 290
// module chunks = 0